import React from "react";

import { parseRuleQuery, translateRuleToPlainText } from "services/rules";
import { useVariables } from "services/variables";

export const RuleQueryInlineView = ({
  ruleQuery,
  withPrefix,
}: {
  ruleQuery: string | null | undefined | (string | null | undefined)[];
  withPrefix?: boolean;
}) => {
  const { variables } = useVariables();

  const processRule = (rule: string | null | undefined): string | null => {
    if (!rule?.trim()) return null;
    const parsedRule = parseRuleQuery(rule);

    return parsedRule
      ? translateRuleToPlainText(parsedRule, variables || [])
      : null;
  };

  // Normalize input to array
  const rulesArray = Array.isArray(ruleQuery) ? ruleQuery : [ruleQuery];
  const processedRules = rulesArray.map(processRule).filter(Boolean);

  if (processedRules.length === 0) {
    return withPrefix ? <>Available to everyone</> : <>Everyone</>;
  }

  const combinedText = processedRules.join(" and ");
  const fullText = (withPrefix ? "Available if " : "") + combinedText;

  return <span title={fullText}>{fullText}</span>;
};
